import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const DonutContainer = styled.div<{ size: number }>`
  position: relative;
  display: flex;
  align-items: center;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

export const InnerDonutContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DonutCenterLabel = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  max-width: 100px;
  text-align: center;
`;

export const DonutTotal = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH1)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;
